import styled from 'styled-components';

export const SliderImageStyled = styled.img`
  width: 100%;
`;